export default "__VITE_ASSET__Z1WhZ7YX__"